// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fr","advertDetailHeaderPrice__value":"c-m_fs","advertDetailHeaderPrice__label":"c-m_ft"};